module.exports = __webpack_public_path__ + "img/cluster.3478fb96.svg";